import { render, staticRenderFns } from "./addTenderDocument.vue?vue&type=template&id=30b10a3d&scoped=true&"
import script from "./addTenderDocument.vue?vue&type=script&lang=js&"
export * from "./addTenderDocument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30b10a3d",
  null
  
)

export default component.exports